import { api } from "./api";
import { readApiErrorMessage } from "./apiErrorMessage";

/**
 * Normalize axios/api() responses into success payload or a thrown Error with user-facing message.
 */
export function assertApiSuccess(response, fallbackMessage) {
  if (!response) {
    throw new Error(
      fallbackMessage ||
        "No response from server. Check your connection and try again."
    );
  }
  if (response.isTimeout || response.status === 0) {
    throw new Error(
      response.data?.details ||
        response.timeoutMessage ||
        "Request timed out. Please try again."
    );
  }
  if (!response.data?.success) {
    throw new Error(
      readApiErrorMessage(response) ||
        response.data?.message ||
        fallbackMessage ||
        "Request failed."
    );
  }
  return response.data;
}

export async function redemptionGet(endpoint) {
  const response = await api(endpoint, "GET");
  return assertApiSuccess(response, `Failed to load ${endpoint}`);
}

export async function redemptionPost(endpoint, body) {
  const response = await api(endpoint, "POST", body);
  return assertApiSuccess(response, `Failed to complete ${endpoint}`);
}
